// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const HalfLeaveFormSingle = () => {
//   // Extracting leaveformId using regular expressions
//   const location = useLocation();
//   // const leaveformId = location.pathname.match(/\/class\/(\d+)/);
//   const leaveformId = location.pathname.match(/\/half-leave-form\/(\d+)/)?.[1];

//   const [leaveform, setleaveform] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchClass = async () => {
//     try {
//       const response = await fetch(
//         `${serverUrl}/student/leave_form/${leaveformId}`
//       );
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setleaveform(data);
//       localStorage.setItem("lformData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (leaveformId) {
//       fetchClass();
//     }
//   }, [leaveformId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Leave Form Details</h1>
//                 <div className="item">
//                   leave:
//                   <img
//                     src={leaveform?.data.leave_file_url}
//                     alt=""
//                     className="itemImg"
//                   />
//                   <div className="details">
//                     <h1 className="itemTitle">
//                       {leaveform?.data.student_names}
//                     </h1>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{leaveform?.data.id}</span>
//                                         </div> */}
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{leaveform?.data.center_id}</span>
//                                         </div> */}
//                     <div className="detailItem">
//                       <span className="itemKey">User: </span>
//                       <span className="itemValue">
//                         {leaveform?.data.user_names}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">From Date: </span>
//                       <span className="itemValue">
//                         {leaveform?.data.start_date_time}
//                       </span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">To Date: </span>
//                       <span className="itemValue">
//                         {leaveform?.data.end_date_time}
//                       </span>
//                     </div>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Time: </span>
//                                             <span className="itemValue">{leaveform?.data.time}</span>
//                                         </div> */}
//                     <div className="detailItem">
//                       <span className="itemKey">Reason for Leave: </span>
//                       <span className="itemValue">
//                         {leaveform?.data.reason}
//                       </span>
//                     </div>
//                     {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{leaveform?.data.status}</span>
//                                         </div> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default HalfLeaveFormSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const HalfLeaveFormSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const leaveformId = location.pathname.match(/\/half-leave-form\/(\d+)/)?.[1];
  const [leaveform, setLeaveform] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchLeaveForm = async () => {
    try {
      const response = await fetch(
        `${serverUrl}/student/leave_form/${leaveformId}`
      );
      const data = await response.json();
      setLeaveform(data);
      localStorage.setItem("lformData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (leaveformId) {
      fetchLeaveForm();
    }
  }, [leaveformId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Leave Form Details</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Leave Form Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Student Avatar */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <span className="text-2xl md:text-3xl text-purple-600">
                          {leaveform?.data.student_names
                            ?.charAt(0)
                            .toUpperCase()}
                        </span>
                      </div>
                    </div>

                    {/* Student Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {leaveform?.data.student_names}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {leaveform?.data.user_names && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">
                              Approved By:
                            </span>
                            <span className="font-medium">
                              {leaveform.data.user_names}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Leave Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Leave Period
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {leaveform?.data.start_date_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          From Date
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {leaveform.data.start_date_time}
                        </p>
                      </div>
                    )}

                    {leaveform?.data.end_date_time && (
                      <div>
                        <label className="block text-sm text-gray-500 mb-2">
                          To Date
                        </label>
                        <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                          {leaveform.data.end_date_time}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Reason Section */}
                {leaveform?.data.reason && (
                  <div className="bg-white rounded-xl p-6 shadow-sm">
                    <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                      Reason for Leave
                    </h3>
                    <p className="text-gray-800 bg-gray-50 rounded-lg p-4">
                      {leaveform.data.reason}
                    </p>
                  </div>
                )}

                {/* Supporting Document */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Supporting Document
                  </h3>

                  {leaveform?.data.leave_file_url ? (
                    <div className="relative group">
                      <img
                        src={leaveform.data.leave_file_url}
                        alt="Leave form document"
                        className="w-full h-48 object-contain border-2 border-gray-200 rounded-lg cursor-pointer hover:border-purple-300 transition-colors"
                        onLoad={() => setImageLoaded(true)}
                        onClick={() =>
                          window.open(leaveform.data.leave_file_url, "_blank")
                        }
                      />
                      {!imageLoaded && (
                        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-lg">
                          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-500"></div>
                        </div>
                      )}
                      <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                        Click to view full size
                      </div>
                    </div>
                  ) : (
                    <div className="bg-gray-50 rounded-lg p-8 text-center text-gray-400">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-12 w-12 mx-auto mb-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      No document attached
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HalfLeaveFormSingle;
